import React, { memo } from 'react';
import { Icons } from '../Icons';
import { useLanguage } from '../../contexts/LanguageContext';

const isBlocked = (error) => {
  const lower = error.toLowerCase();
  return lower.includes('blokován') || lower.includes('blokované') || lower.includes('blokováno') || 
         lower.includes('blocked') || lower.includes('blocking');
};

const isCruxError = (error) => error.includes('CrUX');

export const AnalysisErrorMessage = memo(({ 
  error, 
  dataSource, 
  onFallbackToPageSpeed 
}) => {
  const { t } = useLanguage();
  
  if (!error) return null;

  const blocked = isBlocked(error);
  const cruxError = isCruxError(error);

  const borderColor = blocked ? 'border-yellow-500' : cruxError ? 'border-amber-500' : 'border-red-500';
  const iconColor = blocked ? 'text-yellow-400' : cruxError ? 'text-amber-400' : 'text-red-400';
  const textColor = blocked ? 'text-yellow-400' : cruxError ? 'text-amber-400' : 'text-red-400';
  const title = blocked 
    ? t('ui.analysisError.analysisBlocked') 
    : cruxError 
      ? t('ui.analysisError.cruxNotAvailable') 
      : t('ui.analysisError.analysisError');

  return (
    <div className={`glass-card p-6 mb-8 border-l-4 animate-slide-in ${borderColor}`}>
      <div className="flex items-start gap-3">
        <Icons.Warning size={28} className={iconColor} />
        <div className="flex-1">
          <h3 className="font-semibold mb-1">{title}</h3>
          <p className={`text-sm mb-3 ${textColor}`}>{error}</p>
          {cruxError && dataSource === 'crux' && onFallbackToPageSpeed && (
            <div className="flex flex-wrap gap-2">
              <button
                onClick={onFallbackToPageSpeed}
                className="px-4 py-2 bg-blue-500/20 hover:bg-blue-500/30 border border-blue-500/50 rounded-lg text-blue-400 text-sm font-medium transition-all flex items-center gap-2"
              >
                <Icons.Flask size={16} />
                {t('ui.analysisError.runPageSpeedAudit')}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

export default AnalysisErrorMessage;
